import { Button, TextField, TextareaAutosize } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
//import ImageUploader from './ImageUploader';
import ImageUploaderNew from './ImageUploaderNew';
import { GriderLayout } from './GriderLayout';
import { generateSlug } from '../../../helpers/randoms';
import { useDispatch, useSelector } from 'react-redux';
import { addTemplate } from '../../redux/slices/templateSlice';
import { MessageContext } from '../../contexts/MessageContext';
import CircularProgress from '@mui/material/CircularProgress';
import { Save, SaveAltTwoTone, TaskAlt } from "@mui/icons-material";

/*
  Objectives:
  1. Creates templates from sections like Few and design - like a blog page
  2. Dummy content to fill it up.
  3. Link sections with AI prompts on variables, to different field. Later you could add openai plugins too to access internet etc
  4. Insert sections like: write short testimonials to put on {section_identifier.title} for my {company} - like it can write case study pages if customer gives some info about customer_company+name+designation
  5. A subscribe form, with Heading changing to above stuff
  6. A image automatically added/suggested/generated
  7. Create Excerpts
*/
const GlobalTemplateForm = ({ data = {}, onUpdate }) => {
  console.log('in page form: new',data);
  //const [slugEditedManually, setSlugEditedManually] = useState(false);
  const [pageData, setPageData] = useState(data || {});
  const [pageTitle, setPageTitle] = useState(data.title || '');
  const [pageName, setPageName] = useState(data.name || '');
  const [pageURL, setPageURL] = useState(data.url || '');
  const [redirectTo, setRedirectTo] = useState(data.redirectTo || '');
  const [is404Page, setIs404Page] = useState(data.is404 || false);
  const [slugEditedManually, setSlugEditedManually] = useState(false);
  const [nameEditedManually, setNameEditedManually] = useState(false);
  
  const [isAddingTemplate,setIsAddingTemplate] = useState(false);
  const [isAddedTemplate,setIsAddedTemplate] = useState(false);
  const [sectionTemplates, setSectionTemplates] = useState([]);
  const [pageTemplates, setPageTemplates] = useState([]);
      
  const dispatch = useDispatch();
  const { addMessage } = useContext(MessageContext);
  
  const templatesData = useSelector(state => state.templates.templates);
  const sectionTemplatesData = useSelector(state => state.templates.sectionTemplates);
  const pageTemplatesData = useSelector(state => state.templates.pageTemplates);

  const handleSave = () => {
    let toSaveData = {name: pageName, title: pageTitle, url: pageURL}; //, redirectTo: redirectTo, is404: is404Page};
    onUpdate(toSaveData);
  };

  const onSelectDesign = (e) => {
    console.log('design output',e)
    onUpdate(e);
  };
  
  useEffect(() => {
    if (sectionTemplatesData) {
        setSectionTemplates(sectionTemplatesData)
    }
  }, [sectionTemplatesData]);

  useEffect(() => {
    // If the initial slug is not the auto-generated version of the name,
    // assume it was manually set.
      if (data.url && data.url !== generateSlug(data.title)) {
        setSlugEditedManually(true);
      }
      if (data.name && data.name !== data.title) {
          setSlugEditedManually(true);
      }
  }, [data.title, data.url, data.name]);


  const handleTitleChange = (title) => {
    console.log(title)
    setPageTitle(title);
    // If slug hasn't been edited manually, generate and set slug based on name
    if (!slugEditedManually) {
      setPageURL(generateSlug(title));
    }
    // if display name is blank
    if (!nameEditedManually) {
      setPageName(title);
    }
  }
  
  const handleSlugChange = (slug) => {
    setPageURL(slug);
    setSlugEditedManually(true);  // Mark slug as edited manually
  };

  const handleNameChange = (name) => {
    setPageName(name);
    setNameEditedManually(true);  // Mark slug as edited manually
  };



  const onAddTemplate = async (data={},type='section') => {
    if(type==='section') {
        setIsAddingTemplate(true); 
        dispatch(addTemplate({type: type, data: {...data}, name: (data.headline) ? data.headline : `A ${type} template`}))
        //.then((res) => {
            setTimeout(() => {
                setIsAddedTemplate(true);
                setIsAddingTemplate(false);
            }, 1000)
        //})
    } else if(type==='page') {
        setIsAddingTemplate(true);
        dispatch(addTemplate({type: type, data: {...data}, name: (data.name) ? data.name : `A ${type} template`}))
        //.then((res) => {
            setTimeout(() => {
                setIsAddedTemplate(true);
                setIsAddingTemplate(false);
            }, 1000)
        //})
    }
}

  

  return (
    <div>
      {isAddingTemplate && <span className="ms-3" ><CircularProgress /></span>}
            {isAddedTemplate && <span className="ms-3" ><TaskAlt /></span>}
            {!isAddingTemplate && !isAddedTemplate &&
                <span 
                    className="pointer" 
                    onClick={() => onAddTemplate(data,'section')}
                    alt='Save this block as a template' 
                    title='Save this block as a template'>
                        <SaveAltTwoTone />
                </span>
      }      
      {sectionTemplates &&
                <>
                    <h5>Add Saved sections</h5>
                    {sectionTemplates.map((sectionTemplate,sectionTemplateIndex) => (
                        <>
                        <Button 
                            variant="outlined" 
                            color="primary"
                            className="mx-1 mb-2"
                            onClick={() => onSelectDesign(sectionTemplate?.data?.designProperties)}
                            key={sectionTemplateIndex}
                        >
                            + {sectionTemplate.name}
                        </Button>
                        </>
                    ))}
                </>
      }    
      <label>
        <TextField 
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'Display Name/Page Title'}
          value={pageTitle}
          onChange={(e) => handleTitleChange(e.target.value)}
        />
      </label>
      <label>
        <TextField 
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'Internal Name'}
          value={pageName}
          onChange={(e) => handleNameChange(e.target.value)}
        />
      </label>
      <label>
        <TextField 
          variant="outlined"
          fullWidth 
          style={{ marginTop: 11 }}
          label={'URL'}
          placeholder='Provide the last part of the URL, else Page Name will be taken as URL'
          value={pageURL}
          onChange={(e) => handleSlugChange(e.target.value)}
        />
      </label>
      <br />
      <Button onClick={handleSave} fullWidth className='my-3' variant='outlined' color='primary'>Save</Button>
    </div>
  );
};

export default GlobalTemplateForm;
